export type Audit = {
    auditDate: string
    userName: string
    entityName: string
    entityType: string
    fields: AuditField[]
}

export type AuditResult = {
    items: Audit[],
    totalCount: number,
    pageSize: number,
    page: number,
}

export type AuditField = {
    fieldName: string
    oldValue: string
    newValue: string
    action: string
}

type AuditSearchValueResolver = (audit: Audit) => string[]

const includesSearchText = (value: string | undefined, searchText: string) => {
    return !!value && value.toLowerCase().includes(searchText)
}

export const auditMatchesSearch = (
    audit: Audit,
    searchText: string,
    getAdditionalSearchValues?: AuditSearchValueResolver,
): boolean => {
    const normalizedSearchText = searchText.trim().toLowerCase()

    if (!normalizedSearchText) {
        return true
    }

    const additionalSearchValues = getAdditionalSearchValues ? getAdditionalSearchValues(audit) : []

    return (
        includesSearchText(audit.userName, normalizedSearchText) ||
        includesSearchText(audit.entityName, normalizedSearchText) ||
        includesSearchText(audit.auditDate, normalizedSearchText) ||
        additionalSearchValues.some((value) => includesSearchText(value, normalizedSearchText)) ||
        audit.fields.some(
            (field) =>
                includesSearchText(field.fieldName, normalizedSearchText) ||
                includesSearchText(field.oldValue, normalizedSearchText) ||
                includesSearchText(field.newValue, normalizedSearchText),
        )
    )
}
        export const filterAudits = (
            audits: Audit[],
            searchText: string,
            getAdditionalSearchValues?: AuditSearchValueResolver,
        ): Audit[] => {
            return audits.filter((audit) => auditMatchesSearch(audit, searchText, getAdditionalSearchValues))
}
